<template>
  <div class="page-container">
    <!-- 첫 번째 페이지 -->
    <div v-if="currentPage === 1">
      <section class="mt-4 mb-10">
        <h1 v-if="me" class="font-size--24 mt-10">비상금 대출</h1>
        <p class="description font-size--16 mt-4">
          매출 데이터를 분석해서<br />
          120일 간 안전하게 상환하실 한도를 산출합니다.
        </p>
        <div class="image-container">
          <img
            src="@/assets/images/fastloan/funda_loan.png"
            alt="BNK 설명"
            class="full-width-image"
          />
        </div>
      </section>
      <v-footer fixed>
        <v-layout :class="{ 'px-3': !$vuetify.breakpoint.mobile }">
          <BasicButton class="button next-button" depressed height="48" @click="nextPage">
            다음
          </BasicButton>
        </v-layout>
      </v-footer>
    </div>

    <!-- 두 번째 페이지 -->
    <div v-else>
      <section class="mt-4 mb-10">
        <h1 v-if="me" class="font-size--24 mt-10">비상금 대출</h1>
        <p class="description font-size--16 mt-4">
          BNK 경남은행 계좌를 개설하시고<br />
          매일 매출의 일부(3~15%)가 자동 상환됩니다.
        </p>
        <div class="image-container">
          <img src="@/assets/images/fastloan/bnk.png" alt="대출 설명" class="full-width-image" />
        </div>
      </section>
      <section>
        <ul class="font-size--14 color--nice-grey outer">
          <li>경남은행 계좌는 대출 원금과 이자 상환 전용 게좌로 사용됩니다.</li>
          <li>
            카드, 배달 플랫폼의 모든 매출은 경남은행을 통해 펀다에이아이에 입금되며, 매일 상환금액을 제한
            나머지 매출은 고객님 주계좌로 당일(오후 12~1시) 자동 반환됩니다.
          </li>
        </ul>
      </section>
      <v-footer fixed>
        <v-layout :class="{ 'px-3': !$vuetify.breakpoint.mobile }">
          <BasicButton class="button next-button" depressed height="48" @click="fastLoan300">
            한도 확인하기(수분~수십분 소요)
          </BasicButton>
        </v-layout>
      </v-footer>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import { redirectSignupManage } from '@/util/signupManage'

export default {
  data() {
    return {
      requests: [],
      currentPage: 1,
    }
  },
  computed: {
    ...mapState('auth', ['me']),
    // 진행중인 fast_loan request가 있는지 확인
    hasFastLoanRequest() {
      return this.requests?.find(
        (r) => r.type === 'fast_loan' && ['init', 'approve'].includes(r.status),
      )
    },
  },
  async created() {
    _meta({
      titles: ['300만원비상금대출 설명'],
    })
    if (await redirectSignupManage()) {
      return
    }

    // request 목록 조회
    await this.getRequests()

    // fast_loan request가 있으면 wait 페이지로 리다이렉트
    // if (this.hasFastLoanRequest) {
    //   await this.$router.replace('/loan/fast-loan-300-wait')
    // }
  },
  methods: {
    ...mapActions('auth', ['getMe']),
    ...mapActions('loansRequest', {
      storeAddRequest: 'addRequest',
      storeGetRequests: 'getRequests',
    }),
    async getRequests() {
      try {
        const { data } = await this.storeGetRequests({
          page: 1,
          size: 1000,
          type: 'fast_loan',
        })
        this.requests = data
      } catch (error) {
        console.error('Failed to fetch requests:', error)
      }
    },
    async fastLoan300() {
      await this.$router.push('/loan/fast-loan-300')
    },
    nextPage() {
      this.currentPage = 2
    },
  },
}
</script>
<style lang="scss" scoped>
#section__success {
  .v-card {
    background-color: #f4faff;
  }
}
.image-container {
  margin: 20px 0;

  .full-width-image {
    width: 100%;
    height: auto;
    object-fit: cover;
  }
}
.description {
  color: #666666;
  line-height: 1.5;
  text-align: left;
  margin-bottom: 24px;
  padding: 0 0px;
}
</style>
